import algoliaExportCSV from "../../algolia/api/algoliaExportCSV";

export default function articlesExportCSV({ query, filters }) {
	return algoliaExportCSV({
		index: "articles",
		query,
		filters,
		columns: [
			["ID", (item) => item.id],
			["ISBN", (item) => item.isbn],
			["Type", (item) => item.type],
			["Language", (item) => item.language],
			["Title", (item) => item.name],
			["Series", (item) => item.serie?.name],
			["Series Number", (item) => item.serieNumber],
			["Authors", (item) => item.authors],
			["Translators", (item) => item.translators],
			["Narrators", (item) => item.narrators],
			["Publisher", (item) => item.publisher?.name],
		],
		attributes: [
			"id",
			"isbn",
			"type",
			"language",
			"name",
			"serie",
			"serieNumber",
			"authors",
			"translators",
			"narrators",
			"publisher",
		],
	});
}
